// utils/splitHtml.ts
export function splitHtmlByParagraphCount(html: string, n: number) {
    if (!html) return { topHtml: '', bottomHtml: '' };

    // 元素節點解析（避免純文字換行造成 childNodes 混雜）
    const container = document.createElement('div');
    container.innerHTML = html;

    const top = document.createElement('div');
    const bottom = document.createElement('div');

    let pCount = 0;
    Array.from(container.children).forEach((el) => {
        const isP = el.tagName.toLowerCase() === 'p';
        if (isP && pCount < n) {
            top.appendChild(el.cloneNode(true));
            pCount++;
        } else {
            bottom.appendChild(el.cloneNode(true));
        }
    });

    return { topHtml: top.innerHTML, bottomHtml: bottom.innerHTML };
}
